const EMAIL = "contact@blumen.solutions"

const SOCIALS = [
  {
    label: "X (Twitter)",
    href: "https://x.com/blumensolution",
    icon: (
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden
      >
        <path d="M18.244 2H21.5l-7.55 8.63L22.85 22h-6.96l-5.45-7.13L4.2 22H.94l8.08-9.23L.65 2h7.14l4.93 6.52L18.244 2Zm-2.44 18h1.87L7.28 3.88H5.28l10.525 16.12Z" />
      </svg>
    ),
  },
]

export function SideRails() {
  return (
    <>
      {/* LEFT RAIL — social icons + vertical line */}
      <aside
        aria-hidden="false"
        aria-label="Social links"
        className="pointer-events-none fixed bottom-0 left-5 z-40 hidden flex-col items-center gap-0 xl:flex"
      >
        <ul className="pointer-events-auto flex flex-col items-center gap-7">
          {SOCIALS.map((s) => (
            <li key={s.label}>
              <a
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                className="inline-flex text-foreground/70 transition-all duration-200 hover:-translate-y-0.5 hover:text-primary"
              >
                {s.icon}
              </a>
            </li>
          ))}
        </ul>
        <span aria-hidden className="mt-7 block h-[110px] w-px bg-foreground/30" />
      </aside>

      {/* RIGHT RAIL — rotated email + vertical line */}
      <aside
        aria-hidden="false"
        aria-label="Contact"
        className="pointer-events-none fixed bottom-0 right-5 z-40 hidden flex-col items-center gap-8 xl:flex"
      >
        <a
          href={`mailto:${EMAIL}`}
          className="write-vertical pointer-events-auto font-mono text-[11px] tracking-[0.22em] text-foreground/70 transition-colors hover:text-primary"
        >
          {EMAIL}
        </a>
        <span aria-hidden className="block h-[110px] w-px bg-foreground/30" />
      </aside>
    </>
  )
}
